import React from 'react';
import { useTranslation } from 'react-i18next';
import galleryImagesList from '../gallery-images.json';

function Gallery({ settings }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // Title fallback logic
  const title = (currentLang === 'en' ? settings?.galleryTitleEn : settings?.galleryTitleBs) 
    || (currentLang === 'en' ? 'Every detail is part of the memory we create together.' : 'Svaki detalj je dio uspomene koju stvaramo zajedno.');

  // Use selected images from settings, or fallback to local images if none selected
  const displayImages = settings?.galleryImages && settings.galleryImages.length > 0 
    ? settings.galleryImages 
    : galleryImagesList.map(img => `/img/gallery/${img}`);

  return (
    <div className="w-full bg-[#fcfaf8] py-16 md:py-32 px-6 md:px-12 lg:px-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto">
        
        {/* Title */}
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif text-gray-900 uppercase tracking-tight">
            {title}
          </h2>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {displayImages.map((img, index) => (
            <div key={index} className="relative aspect-[3/4] overflow-hidden group cursor-pointer shadow-sm bg-gray-100">
              <img
                src={img}
                alt={`Wedding moment ${index + 1}`}
                className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Gallery;
